import React, { useContext } from 'react';
import { Layout, Row, Col } from 'antd';
import UserProfile from './user-profile';
import { AppContext } from '@CONTEXTS';
import './index.scss';

const { Header } = Layout;

const LayoutHeader = ({ setChangingMerchant }) => {
  const { title } = useContext(AppContext);
  return (
    <Header className="app-header">
      <Row gutter={12}>
        <Col flex="auto">
          <h1>{title}</h1>
        </Col>
        <Col flex="none">
          <UserProfile setChangingMerchant={setChangingMerchant} />
        </Col>
      </Row>
    </Header>
  );
};

export default LayoutHeader;
